import { TabStyles } from '@tableau/widgets';
import React from 'react';
import _ from 'underscore';

import { ProfilePicture } from '../../common/react/components/ProfilePicture';
import { Helpers } from '../../ts/helpers/Helpers';
import { HeaderStyles } from '../header/HeaderStyles';
import { ProfilePictureStyles } from './styles/ProfilePictureStyles';

const LETTERS_ALL = 'ALL';

export function DataGridProfilePicture(props: DataGridProfilePicture.Props): JSX.Element {
  const divStyle = ProfilePictureStyles.Layout.CenterSingleChild;

  let profilePictureProps = {
    contentLetters: Helpers.generateAbbrevFromName(props.profileDisplayName),
    sizeInPixels: ProfilePictureStyles.Sizes.ExtraSmallIconSize,
    fontSizeInPixels: ProfilePictureStyles.FontSizes.ExtraSmallIconFontSize,
    fillColor: HeaderStyles.HeaderBackgroundColor,
    shape: props.divShape,
    imageUrl: props.imageUrl
  };

  if(props.isAllUsersGroup){
    profilePictureProps = _.assign({}, profilePictureProps, {
      contentLetters: LETTERS_ALL,
      fillColor : TabStyles.Typography.Color.InvertedPrimary,
      textColor: HeaderStyles.HeaderBackgroundColor,
      borderColor: HeaderStyles.HeaderBackgroundColor,
      borderWidth: 1
    });
  }

  return (
    <div style={divStyle}>
      <ProfilePicture {...profilePictureProps} />
    </div>
  );
}

export module DataGridProfilePicture {

  export interface Props {
    profileDisplayName: string;
    imageUrl: string;
    divShape: ProfilePicture.Shape;
    isAllUsersGroup?: boolean;
  }

}
